export default __webpack_public_path__ + "static/media/slide3.8ebee2cd.png";